import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import moment from 'moment';
import { openModal } from '../../actions/ModalActions';
import discountApi from '../../components/discounts/discountApi';
import PromotionFormModal from '../../components/discounts/PromotionFormModal';
import PromotionCodeModal from '../../components/discounts/PromotionCodeModal';
import BulkApplyModal from '../../components/discounts/BulkApplyModal';
import ConfirmModal from '../../components/discounts/ConfirmModal';
import { shortDate, percent, durationLabel, couponTerms, labelClass } from '../../utils/discountFormat';

/** OPE-112: one promotion — campaign detail, lifecycle, the coupon it points at, audit history. */
@connect(
    state => ({ canManage: state.auth.user.permissions.includes('MANAGE_DISCOUNTS') }),
    dispatch => bindActionCreators({ openModal }, dispatch)
)
export default class Promotion extends Component {
    constructor(props) {
        super(props);
        this.state = { promotion: null, reference: null, audit: null, error: null, actionError: null, isActing: false };
    }

    componentDidMount() {
        discountApi.referenceData().then(reference => this.setState({ reference })).catch(error => this.setState({ error: error.message }));
        this.load();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.routeParams.id != this.props.routeParams.id) {
            this.load(nextProps.routeParams.id);
        }
    }

    componentWillUnmount() {
        document.title = 'Fergus CRM';
    }

    load(id = this.props.routeParams.id) {
        discountApi.getPromotion(id)
            .then(promotion => {
                document.title = `${promotion.name} | Discounts | Fergus CRM`;
                this.setState({ promotion, error: null });
            })
            .catch(error => this.setState({ error: error.message }));
        discountApi.promotionAudit(id).then(audit => this.setState({ audit })).catch(() => {});
    }

    act(action, id, target) {
        this.setState({ isActing: true, actionError: null });
        var request = target === 'coupon' ? discountApi.couponAction(id, action) : discountApi.promotionAction(id, action);
        request.then(() => { this.setState({ isActing: false }); this.load(); })
            .catch(error => this.setState({ isActing: false, actionError: error.message }));
    }

    confirmArchive(p) {
        this.setState({ actionError: null });
        this.props.openModal(ConfirmModal, {
            title: 'Archive promotion',
            message: `Archive "${p.name}"? It can no longer be applied. Discounts already given to clients are not affected, and the coupon stays available to other promotions.`,
            confirmText: 'Archive',
            onConfirm: () => this.act('archive', p.promotion_id)
        });
    }

    render() {
        var { promotion: p, reference, audit, error, actionError, isActing } = this.state;
        var canManage = this.props.canManage;
        if (error) {
            return <div className="alert alert-danger">{error}</div>;
        }
        if (!p || !reference) {
            return <p className="text-muted">Loading...</p>;
        }
        var editable = p.status !== 'archived' && p.status !== 'ended';
        var c = p.coupon;
        var productName = (key, type) => {
            if (type === 'user_type') {
                var seat = (reference.user_types || []).find(u => u.key === key);
                return seat ? `${seat.name} (seat type)` : key;
            }
            if (key === reference.sms_product_key) { return 'SMS blocks'; }
            var product = reference.products.find(x => (x.product_ids || []).includes(key));
            return product ? product.name : key;
        };
        var targetNames = coupon => {
            var seen = {};
            return (coupon.targets || []).map(t => productName(t.target_key, t.target_type)).filter(n => (seen[n] ? false : (seen[n] = true))).join(', ');
        };

        return (
            <div className="row page-todo">
                <ol className="breadcrumb page-breadcrumb">
                    <li><Link to="/discounts">Coupons</Link></li>
                    {c && <li><Link to={`/discounts/coupons/${c.coupon_id}`}>{c.invoice_name}</Link></li>}
                    <li className="active">{p.code || p.name}</li>
                </ol>
                <div className="col-md-12">
                    {actionError && <div className="alert alert-danger">{actionError}</div>}

                    <div className="panel panel-default">
                        <div className="panel-heading" style={{ display: 'flex', alignItems: 'center' }}>
                            <h2 style={{ flex: 1, margin: 0 }}>{p.code ? <code>{p.code}</code> : p.name} <span className={labelClass(p.status)} style={{ marginLeft: 8, verticalAlign: 'middle' }}>{p.status}</span>{p.code && <small className="text-muted" style={{ marginLeft: 8 }}>{p.name}</small>}</h2>
                            {canManage && editable &&
                                <button type="button" className="btn btn-sm btn-default" style={{ marginRight: 6 }} disabled={isActing}
                                    onClick={() => this.props.openModal(PromotionFormModal, { promotion: p, reference, onDone: () => this.load() })}>
                                    <i className="fa fa-pencil"></i> Edit
                                </button>
                            }
                            {canManage && (p.status === 'draft' || p.status === 'paused') &&
                                <button type="button" className="btn btn-sm btn-success" style={{ marginRight: 6 }} disabled={isActing} onClick={() => this.act('activate', p.promotion_id)}>Activate</button>
                            }
                            {canManage && p.status === 'active' &&
                                <button type="button" className="btn btn-sm btn-warning" style={{ marginRight: 6 }} disabled={isActing} onClick={() => this.act('pause', p.promotion_id)}>Pause</button>
                            }
                            {canManage && p.status === 'active' && c && c.state === 'active' &&
                                <button type="button" className="btn btn-sm btn-info" style={{ marginRight: 6 }} disabled={isActing}
                                    onClick={() => this.props.openModal(BulkApplyModal, { promotion: p, countries: reference.countries, promotionCountries: p.countries, onDone: () => this.load() })}>
                                    Bulk apply&hellip;
                                </button>
                            }
                            {canManage && p.status !== 'archived' &&
                                <button type="button" className="btn btn-sm btn-danger" disabled={isActing} onClick={() => this.confirmArchive(p)}>Archive</button>
                            }
                        </div>
                        <div className="panel-body">
                            <dl className="dl-horizontal" style={{ marginBottom: 0 }}>
                                <dt>Slug</dt><dd>{p.slug}</dd>
                                <dt>Scheme</dt><dd>{p.scheme_type}</dd>
                                <dt>Promotion code</dt>
                                <dd>
                                    {p.code ? <code>{p.code}</code> : <span className="text-muted">none</span>}
                                    {canManage && editable &&
                                        <a href="#" style={{ marginLeft: 8 }} onClick={e => { e.preventDefault(); this.props.openModal(PromotionCodeModal, { promotion: p, onDone: () => this.load() }); }}>
                                            <small>{p.code ? 'change' : 'set'}</small>
                                        </a>
                                    }
                                </dd>
                                <dt>Commission impact</dt><dd>{percent(p.effective_commission_impact_ratio)}{p.commission_impact_ratio === null && <small className="text-muted"> inherited from the coupon</small>}{p.commission_impact_ratio !== null && <small className="text-muted"> overrides the coupon</small>}</dd>
                                <dt>Eligibility</dt><dd>{p.customer_eligibility}</dd>
                                <dt>Auto-apply</dt><dd>{p.auto_apply ? 'yes, at paid-plan signup' : 'no'}</dd>
                                <dt>Priority</dt><dd>{p.priority} <small className="text-muted">tie-break only</small></dd>
                                <dt>Countries</dt><dd>{(p.countries || []).join(', ') || '–'}</dd>
                                <dt>Redemption window</dt><dd>{shortDate(p.redemption_starts_at)} – {shortDate(p.redemption_ends_at)}</dd>
                                <dt>Activated</dt><dd>{shortDate(p.activated_at)}</dd>
                            </dl>
                        </div>
                    </div>

                    <div className="panel panel-default">
                        <div className="panel-heading" style={{ display: 'flex', alignItems: 'center' }}>
                            <h2 style={{ flex: 1, margin: 0 }}><i className="fa fa-ticket"></i> Coupon <small className="text-muted">the terms this promotion code gives; shared with any other code on the same coupon</small></h2>
                            {canManage && p.status === 'draft' &&
                                <button type="button" className="btn btn-sm btn-default" onClick={() => this.props.openModal(PromotionFormModal, { promotion: p, reference, onDone: () => this.load() })}>
                                    <i className="fa fa-exchange"></i> {c ? 'Change coupon' : 'Choose coupon'}
                                </button>
                            }
                        </div>
                        <div className="panel-body">
                            {!c && <p className="text-muted" style={{ marginBottom: 0 }}>No coupon chosen yet. The promotion cannot go live until it points at an active coupon — pick one from the <Link to="/discounts">coupons</Link> or create it there first.</p>}
                            {c &&
                                <dl className="dl-horizontal" style={{ marginBottom: 0 }}>
                                    <dt>Coupon</dt>
                                    <dd>
                                        <Link to={`/discounts/coupons/${c.coupon_id}`}>{c.invoice_name}</Link> <span className={labelClass(c.state)} style={{ marginLeft: 6 }}>{c.state}</span>
                                        {canManage && c.state === 'draft' &&
                                            <button type="button" className="btn btn-xs btn-success" style={{ marginLeft: 8 }} disabled={isActing} onClick={() => this.act('activate', c.coupon_id, 'coupon')}>Activate coupon</button>
                                        }
                                        <div className="text-muted"><small>this name is what the customer reads on the invoice</small></div>
                                    </dd>
                                    <dt>Terms</dt><dd>{couponTerms(c)}</dd>
                                    <dt>Scope</dt><dd>{c.scope === 'user_type' ? 'seat types' : c.scope}{c.scope !== 'account' && <span className="text-muted"> — {targetNames(c)}</span>}</dd>
                                    <dt>Duration</dt><dd>{durationLabel(c)}</dd>
                                    <dt>Redemptions</dt><dd>{c.times_redeemed}{c.max_redemptions ? ` of ${c.max_redemptions}` : ' (no limit)'} <small className="text-muted">across every promotion on this coupon</small></dd>
                                </dl>
                            }
                        </div>
                    </div>

                    <div className="panel panel-default">
                        <div className="panel-heading"><h2 style={{ margin: 0 }}><i className="fa fa-history"></i> History</h2></div>
                        <div className="panel-body no-padding">
                            {audit === null && <p className="text-muted" style={{ padding: 10 }}>Loading...</p>}
                            {audit && audit.length === 0 && <p className="text-muted" style={{ padding: 10 }}>No events.</p>}
                            {audit && audit.length > 0 &&
                                <table className="table table-condensed" style={{ marginBottom: 0 }}>
                                    <thead><tr><th>When</th><th>Entity</th><th>Event</th><th>Actor</th><th>Change</th></tr></thead>
                                    <tbody>
                                        {audit.map(e =>
                                            <tr key={e.discount_audit_event_id}>
                                                <td>{moment(e.occurred_at).format('D MMM YYYY HH:mm')}</td>
                                                <td>{e.entity_type}</td>
                                                <td>{e.event_type}</td>
                                                <td>{e.actor_type === 'user' ? (e.actor_name || e.actor_id) : 'system'}</td>
                                                <td><small><code>{JSON.stringify(e.after)}</code></small></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/discounts/Promotion.js